import { withStory, WithStoryProps } from '@storyofams/storyblok-toolkit';
import { GetStaticPaths, GetStaticProps } from 'next';

import { DynamicPage } from '~/components';
import { CookiebannerItem, LandingsettingsItem } from '~/graphql/sdk';
import {
  addFormFieldsToStory,
  enhancedStaticProps,
  sdk as sdkClient,
  withLayout,
} from '~/lib';

export interface LandingPageProps extends WithStoryProps {
  cookieBanner: CookiebannerItem;
  landingSettings: LandingsettingsItem;
}

const LandingPage = ({ ...props }: LandingPageProps) => {
  return <DynamicPage {...props} />;
};

export default withLayout(withStory(LandingPage));

export const getStaticProps: GetStaticProps = enhancedStaticProps(
  async ({ params: { slug }, sdk }) => {
    let story;
    let notFound = false;

    try {
      story = (await sdk.pageItem({ slug: `/lp/${slug}` })).PageItem;
      story = await addFormFieldsToStory(story);
    } catch (e) {
      notFound = true;
    }

    return {
      props: {
        story,
      },
      notFound: notFound || !story,
      revalidate: 60,
    };
  },
);

export const getStaticPaths: GetStaticPaths = async () => {
  let stories;

  try {
    stories = (await sdkClient.pageItems()).PageItems.items;
  } catch (e) {}

  return {
    paths: stories
      ?.filter(({ slug }) => slug !== 'home')
      ?.map(({ slug }) => ({
        params: { slug },
      })),
    fallback: 'blocking',
  };
};
